<template>
  <ZDialog :show="isVisible" :modal-size="modalSize" :dStyle="'z-index: 1070'" :bdStyle="'z-index: 1065'">
    <template #header>
      <div class="custom-header">
        <div class="row">
          <div class="col-md-11">
            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>
          <div class="col-md-1">
            <a href="#" @click="close" class="custom-close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </div>
    </template>
    <template #body>
      <div class="hostWrapper">
        <object width="100%" :height="height" :data="previewContent" :type="mimeType"></object>
      </div>
    </template>
    <template #footer>
      <div class="custom-footer">
        <div class="row">
          <div class="col-1 text-right">
            <button type="button" class="btn btn-default" @click="close()">Close</button>
          </div>
        </div>
      </div>
    </template>
  </ZDialog>
</template>
<script>
import ZDialog from '@/components/utilities/elements/Dialog.vue'
export default {
  name: 'DialogPreview',
  components: {
    ZDialog
  },
  props: {
    modelValue: Object
  },
  data() {
    return {
      modalSize: 'modal-xl',
      height: '100%',
      isLoading: false
    }
  },
  mounted() {
    this.isLoading = false
  },
  computed: {
    isVisible() {
      console.log('DialogPreview isVisible', this.modelValue)
      return this.modelValue !== null
    },
    title() {
      let _data = 'Preview'
      return _data
    },
    mimeType() {
      return this.modelValue ? this.modelValue.mimeType : 'application/pdf'
    },
    previewContent() {
      return this.modelValue ? this.modelValue.content : null
    },
  },
  methods: {
    close() {
      this.$emit('closing')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}

.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}

.custom-footer {
  width: 100%;
}

.custom-right-align {
  text-align: right;
}

.hostWrapper {
  max-height: 750px;
  overflow-x: hidden;
  overflow-y: auto;
  height: 700px;
}
</style>
